import React from "react";
import { Card, Row, Col } from "antd";
import { FaStar } from "react-icons/fa";
import "../../containers/SpAndSuAnalysis/style.css";

const PopularServicesList = ({ services, title }) => {
    return (
        <Card className="popular-services-card" hoverable>
            <div className="popular-services-header">
                <FaStar className="popular-services-icon" />
                <h3 className="popular-services-title">{title}</h3>
            </div>

            <Row gutter={[16, 12]}>
                {
                    services?.length > 0 ?
                        services.map((service, index) => (
                            <Col xs={12} key={service?.id}>
                                <div className="popular-service-item">
                                    <div className="popular-service-dot" />
                                    <span className="popular-service-name">{service?.name}</span>
                                </div>
                            </Col>
                        ))
                        :
                        <p style={{ textAlign: 'center' }}>No Services Available</p>
                }
            </Row>
        </Card>
    );
};

export default PopularServicesList;
